export const mutations = {
  setOrdemServico(state, payload) {
    state.ordemServico = { ...payload };
  },
  setOrdensServicos(state, payload) {
    state.ordensServicos = payload;
  },
  setModalCadastroOrdemServico(state, payload) {
    state.modalCadastroOrdemServico = payload;
  },
  removeOrdemServico(state, data) {
    let index = state.ordensServicos.data.map((x) => x.id).indexOf(data.id);
    state.ordensServicos.data.splice(index, 1);
  },
  setModalExcluirOrdemServico(state, payload) {
    state.modalExcluirOrdemServico = payload;
  },
  setModalHistoricoStatusOS(state, payload) {
    state.modalHistoricoStatusOS = payload;
  },
  setModalPagamentoOrdemServico(state, payload) {
    state.modalPagamentoOrdemServico = payload;
  },
};

export default {};
